import React from 'react'
import {
    Mail,
    MapPin,
    Phone,
} from "lucide-react";
import empresas from '@/data/empresas.json'
import otrosServicios from '@/data/otrosServicios.json'
import contacto from '@/data/contacto.json'

export default function Footer() {
    return <footer className="text-gray-400 mt-8 bg-primary py-12">
        <div className="container mx-auto px-6 md:px-12">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3">
                {/* Empresas Municipales */}
                <div>
                    <h3 className="mb-4 font-semibold text-white">
                        Empresas Municipales
                    </h3>
                    <ul className="space-y-2">
                        {empresas.map((i, index) => (
                            <li key={index}>
                                <a
                                    href={i.websiteURL}
                                    target="_blank"
                                    rel='noreferrer'
                                    className="block transition-colors hover:text-white"
                                >
                                    {i.nombre}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Otros servicios */}
                <div>
                    <h3 className="mb-4 font-semibold text-white">Otros servicios</h3>
                    <ul className="space-y-2">
                        {otrosServicios.map((i, index) => (
                            <li key={index}>
                                <a
                                    href={i.link}
                                    target="_blank"
                                    rel='noreferrer'
                                    className="block transition-colors hover:text-white"
                                >
                                    {i.nombre}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contacto */}
                <div>
                    <h3 className="mb-4 font-semibold text-white">Contacto</h3>
                    <div className="space-y-3">
                        <p className="flex items-start gap-2">
                            <MapPin className="h-5 w-5" />
                            <span>{contacto.direccion}</span>
                        </p>
                        <p className="flex items-start gap-2">
                            <Phone className="h-5 w-5" />
                            <span>{contacto.telefono}</span>
                        </p>
                        <a
                            href={`mailto:${contacto.email}`}
                            className="flex items-center gap-2 transition-colors hover:text-white"
                        >
                            <Mail className="h-5 w-5" />
                            {contacto.email}
                        </a>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="border-gray-800 mt-8 border-t pt-6 text-center text-sm">
                © {new Date().getFullYear()} GAD Municipal del Cantón Portoviejo -
                Dirección de Tecnología. Todos los derechos reservados.
            </div>
        </div>
    </footer>
}
